mutation LeadAddChannel($input: LeadAddChannelInput!) {
    leadAddChannel(input: $input) {
        lead {
            id
        }
    }
}
